module.exports = __webpack_public_path__ + "img/brunei.159dc6bd.svg";